// extracted by mini-css-extract-plugin
export default {"wrapper":"Preloader_wrapper__hcK2M","preloader":"Preloader_preloader__YoHf7","load":"Preloader_load__w6D+I","round":"Preloader_round__1-kIx"};